import { defineMessages } from 'react-intl'

const scope = 'app.components.DashboardBackdrop'

export default defineMessages({
  labels: {
    internal: {
      id: `${scope}.labels.internal`,
      defaultMessage: 'Internal Data Sources',
    },
    external: {
      id: `${scope}.labels.external`,
      defaultMessage: 'External Data Sources',
    },
  },
})
